import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@shared/store/authStore';

export function useEmployees() {
  const { apiClient } = useAuthStore();

  return useQuery({
    queryKey: ['employees'],
    queryFn: () => apiClient?.getEmployees() || [],
    enabled: !!apiClient,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useServices() {
  const { apiClient } = useAuthStore();

  return useQuery({
    queryKey: ['services'],
    queryFn: () => apiClient?.getServiceList() || [],
    enabled: !!apiClient,
    staleTime: 5 * 60 * 1000,
  });
}

export function useBookingServices() {
  const { apiClient } = useAuthStore();

  return useQuery({
    queryKey: ['booking-services'],
    queryFn: () => apiClient?.getBookingServices() || [],
    enabled: !!apiClient,
    staleTime: 5 * 60 * 1000,
  });
}

export function useEmployeeFreeTime(empId: number, date: string) {
  const { apiClient } = useAuthStore();

  return useQuery({
    queryKey: ['employee-free-time', empId, date],
    queryFn: () => apiClient?.getEmpFreeTime(empId, date) || [],
    enabled: !!apiClient && !!empId && !!date,
    staleTime: 1 * 60 * 1000, // 1 minute for free time
  });
}

// Hook for creating bookings
export function useCreateBooking() {
  const { apiClient } = useAuthStore();

  return {
    createBooking: async (bookingData: any) => {
      if (!apiClient) throw new Error('API client not available');
      return await apiClient.createBooking(bookingData);
    }
  };
}

// Hook for finding clients
export function useFindClient() {
  const { apiClient } = useAuthStore();

  return {
    findClient: async (phone: string) => {
      if (!apiClient) throw new Error('API client not available');
      return await apiClient.findClient({ Phone: phone });
    }
  };
}

// Hook for creating clients
export function useCreateClient() {
  const { apiClient } = useAuthStore();

  return {
    createClient: async (clientData: any) => {
      if (!apiClient) throw new Error('API client not available');
      return await apiClient.createClient(clientData);
    }
  };
}